import { render, staticRenderFns } from "./EditInstitutionPage.vue?vue&type=template&id=30bae714&"
import script from "./EditInstitutionPage.vue?vue&type=script&lang=js&"
export * from "./EditInstitutionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports